export default __webpack_public_path__ + "static/backgroundDirectors-63f367845ea55d87b9f47566dc163fa1.webp";